import { render, staticRenderFns } from "./TransaksiPembayaran.vue?vue&type=template&id=20f2f835&scoped=true&"
import script from "./TransaksiPembayaran.vue?vue&type=script&lang=js&"
export * from "./TransaksiPembayaran.vue?vue&type=script&lang=js&"
import style0 from "./TransaksiPembayaran.vue?vue&type=style&index=0&id=20f2f835&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f2f835",
  null
  
)

export default component.exports